import { render, staticRenderFns } from "./backoffChargeNominalSetting.vue?vue&type=template&id=39878b00&scoped=true&"
import script from "./backoffChargeNominalSetting.vue?vue&type=script&lang=js&"
export * from "./backoffChargeNominalSetting.vue?vue&type=script&lang=js&"
import style0 from "./backoffChargeNominalSetting.vue?vue&type=style&index=0&id=39878b00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39878b00",
  null
  
)

export default component.exports